<svg #svg [style.height.px]="svgLines.length * 100" [style.width.px]="svgLines.length * 100" id="{{id}}-svg">
  <line *ngFor="let line of svgLines" [attr.x1]="line.x1" [attr.y1]="line.y1" [attr.x2]="line.x2" [attr.y2]="line.y2">
  </line>
</svg>

<div class="content" appResize (resize)="repaint()" [id]="id">
  <ng-content></ng-content>
</div>